import type { HTMLAttributes } from 'react'
import { cn } from '@/shared/lib/cn'

export const Card = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <section
    className={cn('rounded-xl border bg-card text-card-foreground shadow-soft', className)}
    {...props}
  />
)
export const CardHeader = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <header className={cn('flex flex-col gap-1.5 p-6', className)} {...props} />
)
export const CardTitle = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={cn('text-xl font-semibold tracking-tight', className)} {...props} />
)
export const CardDescription = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-sm text-muted-foreground', className)} {...props} />
)
export const CardContent = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('p-6 pt-0', className)} {...props} />
)
export const CardFooter = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <footer className={cn('flex items-center p-6 pt-0', className)} {...props} />
)
